import { BASE_NAV_ITEM_KEYS, type BuiltInPageKey } from "./navigation";
import type { VenuePagesRow } from "./venue_pages";

export function parseCityState(cityState: string): { city: string } {
  const [city = ""] = cityState.split(",").map((part) => part.trim());
  return { city };
}

/**
 * Returns the default title/body for a built-in page (Free Shows, Shows
 * Tonight) when the venue has no custom_links content override row. Used by
 * the public page renderers and pre-populated in the dashboard editor so
 * venues can see what visitors see and tweak from there.
 */
export function getBuiltInPageDefaults(
  key: BuiltInPageKey,
  venue: Pick<VenuePagesRow, "name" | "city_state">
): { title: string; body: string } {
  const { city } = parseCityState(venue.city_state);
  switch (key) {
    case BASE_NAV_ITEM_KEYS.FREE_SHOWS:
      return {
        title: `Free Comedy Shows in ${city}`,
        body: `Looking for free things to do in ${venue.city_state}? ${venue.name} regularly hosts free comedy shows in ${city}, bringing live stand-up to the stage at no cover. Free comedy shows in ${city} are a great way to discover new comedians, catch surprise drop-ins, and make a night out plan without the price tag. There aren't many ${city} comedy clubs running free weekly shows with this kind of lineup. Browse the calendar below for upcoming free shows at ${venue.name}.`,
      };
    case BASE_NAV_ITEM_KEYS.SHOWS_TONIGHT:
      return {
        title: `Comedy Shows in ${city} Tonight`,
        body: `Looking for comedy shows in ${city} tonight? ${venue.name} is one of the best places to catch live stand-up in ${venue.city_state}, with shows running most nights of the week. When you're searching for last-minute things to do in ${city}, the options can pile up fast — we wanted to make it easy. Below is a list of tonight's shows, programmed by our team and featuring some of the city's funniest comedians.`,
      };
  }
}
